// @flow

import React from 'react';

type Props = {
  children: React.Node,
  title: React.Fragment,
  className?: string,
}

function MarketingFactColumn({ title, children, className = '' }: Props) {
  return (
    <div className={`facts-column ${className}`}>
      <div className="facts-header">
        {title}
      </div>
      <div className="facts-content-container">
        <div className="facts-content">
          {children}
        </div>
      </div>
    </div>
  );
}

export default MarketingFactColumn;
